import React, { useLayoutEffect, useState, useEffect, useRef } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";

import Modal from "react-modal";
import Swal from "sweetalert2";
import { TextBox, CheckBox, SelectBox } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import { groupService } from "../../../apis/apiServices/Group";
import { assetService } from "../../../apis/apiServices/Asset";

import { categoryService } from "../../../apis/apiServices/Category";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@iconify/react";

// ---------------------------
// NOTE: This file includes small permission-guard changes.
// I marked those changes with comments starting with: // CHANGED:
// Search for "CHANGED" to quickly find them.
// ---------------------------

export default function CategoryComponent(props) {
  // CHANGED: accept props and read featurePermission (default safe object)
  const featurePermission = props?.featurePermission || {};
  const canAdd = !!featurePermission?.canAdd; // CHANGED: gate 'Add' button
  const canEdit = !!featurePermission?.canEdit; // CHANGED: gate edit icon
  const canDelete = !!featurePermission?.canDelete; // CHANGED: gate delete icon

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Category ";
    getCategoryList();
  }, []);

  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [isCityModalOpen, setIsCityModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [AssetGroupList, setAssetGroupList] = useState([]);
  const [AssetTypeList, setAssetTypeList] = useState([]);
  const [errors, setErrors] = useState({});
  const [AssetCategory, setAssetCategory] = useState([]);
  const refDataGrid = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeViewModal = () => {
    setIsModalOpen(false);
  };

  const [Category, setCategory] = useState({
    id: 0,
    code: "",
    name: "",
    ledgerCode: "",
    groupId: 0,
    groupName: "",
    isActive: true,
    assetTypeid: 0,
  });

  const getCategoryList = async () => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      let response = await categoryService.getCategoryList();
      setAssetCategory(response?.data);
      const assetTypeResponse = await assetService.getassetType();
      setAssetTypeList(assetTypeResponse?.data);
      const groupResponse = await groupService.getGroupList();
      setAssetGroupList(groupResponse?.data);
    } catch (error) {
      console.log("Error getCityList===>", error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  useEffect(() => {
    getCategoryList();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    const newErrors = {};
    if (!Category.name) newErrors.name = "Please enter category name";
    if (Category.groupId === 0) newErrors.groupId = "Please select group.";
    if (Category.assetTypeid === 0)
      newErrors.assetTypeid = "Please select asset type.";
    if (!Category.ledgerCode) newErrors.ledgerCode = "Please enter ledger code";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsSubmitted(false);
      return;
    }

    try {
      let body = {
        id: Category.id,
        code: Category?.code || "",
        name: Category?.name || "",
        ledgerCode: Category?.ledgerCode || "",
        groupId: Category?.groupId || 0,
        isActive: Category?.isActive || false,
        assetTypeid: Category?.assetTypeid,
        ModifiedBy: user?.userId,
      };

      const response = await categoryService.addCategory(body);

      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setIsSubmitted(false);
        setErrors(response?.errors || {});
        return;
      }

      getCategoryList();
      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        navigate(("/Category", { replace: true }));
        closeModal();
      });
    } catch (error) {
      console.log(error);
    }
  };

  const openModal = () => {
    setIsCityModalOpen(true);
  };

  const closeModal = () => {
    setIsCityModalOpen(false);
    setIsSubmitted(false);
    setErrors({});
    setCategory({
      id: 0,
      code: "",
      name: "",
      ledgerCode: "",
      groupId: 0,
      groupName: "",
      isActive: true,
      assetTypeid: 0,
    });
  };

  const handleInputChange = (e, field) => {
    let err = { ...errors };
    if (field === "code") {
      err.code = "";
    }
    if (field === "name") {
      err.name = "";
    }
    if (field === "groupId") {
      err.groupId = "";
    }
    if (field === "assetTypeid") {
      err.assetTypeid = "";
    }
    if (field === "ledgerCode") {
      err.ledgerCode = "";
    }
    setErrors(err);
    setCategory((prev) => ({
      ...prev,
      [field]: e.value,
    }));
  };

  const renderStatusCell = ({ value }) => {
    const isActive = value === true;

    return (
      <div>
        <span />
        {isActive ? "Active" : "Inactive"}
      </div>
    );
  };

  const handleRowClick = (e) => {
    setCategory({
      id: e.data.id,
      code: e.data.code,
      name: e.data.name,
      ledgerCode: e.data.ledgerCode,
      isActive: e.data.isActive,
      groupId: e.data.groupId,
      assetTypeid: e.data.assetTypeId,
    });
  };

  // CHANGED: helper to open edit modal and prefill Category state
  const openEditForRow = (rowData) => {
    if (!rowData) return;
    setCategory((prev) => ({
      id: rowData.id || 0,
      code: rowData.code || "",
      name: rowData.name || "",
      ledgerCode: rowData.ledgerCode || "",
      groupId: rowData.groupId || 0,
      groupName: rowData.groupName || "",
      isActive: rowData.isActive ?? true,
      assetTypeid: rowData.assetTypeId || rowData.assetTypeid || 0,
    }));
    setIsCityModalOpen(true);
  };

  const handleDelete = async (id) => {
    if (!id) return;

    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the category.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          refDataGrid?.current?.instance?.beginCustomLoading();

          const response = await categoryService.deleteCategory(id);

          const ok = response?.isSuccess ?? response?.success;

          if (!ok) {
            Swal.fire(
              "Error!",
              response?.message || "Failed to delete.",
              "error"
            );
            return;
          }

          Swal.fire(
            "Deleted!",
            response?.message || "Category deleted.",
            "success"
          );
          await getCategoryList();
        } catch (err) {
          console.error("Delete error =>", err);
          Swal.fire("Error!", "Something went wrong while deleting.", "error");
        } finally {
          refDataGrid?.current?.instance?.endCustomLoading();
        }
      }
    });
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              dataSource={AssetCategory}
              showColumnLines={false}
              ref={refDataGrid}
              showRowLines={true}
              showBorders={true}
              onRowClick={(e) => handleRowClick(e)}
              allowColumnResizing={false}
              allowColumnReordering={true}
              columnAutoWidth={true}
              width={"100%"}
              onToolbarPreparing={(e) => {
                // CHANGED: build toolbar items conditionally based on permissions
                const items = [];

                if (canAdd) {
                  items.push({
                    location: "before",
                    widget: "dxButton",
                    options: {
                      icon: "plus",
                      text: "Add",
                      hint: "Add",
                      type: "default",
                      stylingMode: "contained",
                      onClick: () => openModal(),
                    },
                  });
                }

                items.push({
                  location: "before",
                  widget: "dxButton",
                  options: {
                    icon: "refresh",
                    text: "Refresh",
                    hint: "Refresh",
                    type: "default",
                    stylingMode: "outlined",
                    onClick: () => getCategoryList(),
                  },
                });

                items.push({
                  location: "after",
                  widget: "dxButton",
                  options: {
                    icon: "upload",
                    text: "Upload Category",
                    hint: "Upload Category",
                    type: "default",
                    stylingMode: "outlined",
                    onClick: () => {
                      try {
                        navigate("/UploadCategory");
                      } catch (error) {
                        console.log(error);
                      }
                    },
                  },
                });

                e.toolbarOptions.items.unshift(...items);
              }}
            >
              <HeaderFilter visible={false} />
              <Column
                width={60}
                caption={""}
                cellRender={(cellData) => {
                  return (
                    <span>
                      {/* CHANGED: only show edit icon if canEdit true */}
                      {canEdit && (
                        <Icon
                          className="iconify-size mr-2"
                          title="Edit"
                          tooltip="Edit"
                          icon="solar:pen-line-duotone"
                          style={{ cursor: "pointer" }}
                          onClick={() => openEditForRow(cellData.data)}
                        />
                      )}

                      {/* CHANGED: only show delete icon if canDelete true */}
                      {canDelete && (
                        <Icon
                          className="iconify-size"
                          title="Delete"
                          tooltip="Delete"
                          icon="fluent:delete-32-regular"
                          style={{
                            cursor: "pointer",
                            marginLeft: canEdit ? 8 : 0,
                          }}
                          onClick={() => handleDelete(cellData.data?.id)}
                        />
                      )}
                    </span>
                  );
                }}
              ></Column>

              <Column
                dataField="name"
                caption="Name"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column dataField="code" caption="Code" allowFiltering={false} />
              <Column
                dataField="groupname"
                visible={true}
                caption="Group Name"
                allowFiltering={false}
                allowSearch={true}
                alignment={"left"}
              />
              <Column
                dataField="assetType"
                visible={true}
                caption="Asset Type "
                allowFiltering={false}
                allowSearch={true}
                alignment={"left"}
              />
              <Column
                dataField="ledgerCode"
                caption="Ledger Code"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column
                dataField="isActive"
                caption="Status"
                cellRender={renderStatusCell}
                alignment="left"
                allowSearch={true}
              />
              <Column
                dataField="groupName"
                visible={false}
                caption="Group"
                allowFiltering={false}
                allowSearch={true}
              />

              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />

              <Export enabled={false} fileName="Vendors" />
            </DataGrid>
          </div>
        </div>
      </div>

      <Modal
        ariaHideApp={false}
        isOpen={isCityModalOpen}
        className="react-modal resmodel"
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Category  Type Modal"
      >
        <form
          onSubmit={handleSubmit}
          style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
        >
          <div className="modal-header">
            <div className="modal-title">
              {Category.id === 0
                ? `Add Category`
                : `Update Category [${Category.name}]`}
            </div>
          </div>

          <div className="modal-body">
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group">
                  <label>Code </label>
                  <TextBox
                    className="form-control form-control-sm"
                    height={37}
                    placeholder="Enter Code"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={Category.code}
                    onValueChanged={(e) => handleInputChange(e, "code")}
                  />
                  {errors.code && (
                    <div className="text-danger">{errors.code}</div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-12">
                <div className="form-group">
                  <label>
                    Group Name <span className="text-danger">*</span>{" "}
                  </label>
                  <SelectBox
                    className="basic-multi-select"
                    dataSource={AssetGroupList}
                    showClearButton={true}
                    displayExpr="name"
                    valueExpr="id"
                    placeholder="Select state"
                    value={Category.groupId}
                    onValueChanged={(e) => handleInputChange(e, "groupId")}
                  />
                  {errors.groupId && (
                    <div className="text-danger">{errors.groupId}</div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-12">
                <div className="form-group">
                  <label>
                    Name <span className="text-danger">*</span>
                  </label>
                  <TextBox
                    className="form-control form-control-sm"
                    height={37}
                    placeholder="Enter category name"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={Category.name}
                    onValueChanged={(e) => handleInputChange(e, "name")}
                  />
                  {errors.name && (
                    <div className="text-danger">{errors.name}</div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-12">
                <div className="form-group">
                  <label>
                    Asset Type <span className="text-danger">*</span>{" "}
                  </label>
                  <SelectBox
                    className="basic-multi-select"
                    dataSource={AssetTypeList}
                    displayExpr="name"
                    valueExpr="id"
                    showClearButton={true}
                    placeholder="Select Asset Type"
                    value={Category.assetTypeid}
                    onValueChanged={(e) => handleInputChange(e, "assetTypeid")}
                  />
                  {errors.assetTypeid && (
                    <div className="text-danger">{errors.assetTypeid}</div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-12">
                <div className="form-group">
                  <label>
                    Ledger Code <span className="text-danger">*</span>
                  </label>
                  <TextBox
                    className="form-control form-control-sm"
                    height={37}
                    placeholder="Enter ledger code"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={Category.ledgerCode}
                    onValueChanged={(e) => handleInputChange(e, "ledgerCode")}
                  />
                  {errors.ledgerCode && (
                    <div className="text-danger">{errors.ledgerCode}</div>
                  )}
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div>
                  <CheckBox
                    text="Is Active"
                    value={Category.isActive}
                    onValueChanged={(e) => handleInputChange(e, "isActive")}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeModal}
              title="Cancel"
            >
              <i className="fas fa-times"></i> Cancel
            </button>
            <button type="submit" className="btn btn-primary btn-sm">
              {isSubmitted ? (
                <span title="In process">
                  <i className="fas fa-spinner fa-spin"></i> In process
                </span>
              ) : (
                <span title="Submit">
                  <i className="fas fa-check"></i> Submit
                </span>
              )}
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        ariaHideApp={false}
        isOpen={isModalOpen}
        className="react-modal resmodel"
        onRequestClose={closeViewModal}
      >
        <form
          onSubmit={handleSubmit}
          style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
        >
          <div className="modal-header">
            <div className="modal-title">View Asset Sub Group</div>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <p>
                    <span className="labelview">Code: </span> {Category.code}
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <p>
                    <span className="labelview">Name: </span> {Category.name}
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <p>
                    <span className="labelview">Asset Group: </span>{" "}
                    {
                      AssetGroupList.find(
                        (item) => item.id === Category.groupId
                      )?.name
                    }
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <p>
                    <span className="labelview">Status: </span>{" "}
                    {Category.isActive ? "Active" : "Inactive"}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeViewModal}
              title="Cancel"
            >
              <i className="fas fa-times"></i> Close{" "}
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
